import type { FunctionComponent } from "react"

import { CHATBOT_STUDENTS, CHATBOT_UNI_BO } from "@/modules/helpCenter/flags"
import { useFlag } from "@/modules/unleash/hooks/useFlag"
import { SCHOOL_ADMIN_ROLES } from "@/modules/user/api/types"
import { useCurrentUserFetch } from "@/modules/user/client/hooks/useCurrentUserFetch"

import { WonderchatScript } from "./Wonderchat/WonderchatScript"
import { ZendeskScript } from "./Zendesk/ZendeskScript"

export const ChatBot: FunctionComponent = () => {
  const { dataCurrentUser } = useCurrentUserFetch()
  const isChatbotActiveForUni = useFlag(CHATBOT_UNI_BO)
  const isChatbotActiveForStudentsWithWonderchat = useFlag(CHATBOT_STUDENTS)

  if (!dataCurrentUser?.isLogged) {
    return null
  }

  const userRole = dataCurrentUser.attributes.roleTitle

  if (SCHOOL_ADMIN_ROLES.includes(userRole) && isChatbotActiveForUni) {
    return <WonderchatScript wonderchatKey={process.env.NEXT_PUBLIC_WONDERCHAT_TOKEN || ""} />
  }

  if (["company_super_admin", "company_admin", "company_offers_manager"].includes(userRole)) {
    return <WonderchatScript wonderchatKey={process.env.NEXT_PUBLIC_WONDERCHAT_TOKEN_B2B || ""} />
  }

  if (userRole === "student" && isChatbotActiveForStudentsWithWonderchat) {
    return <WonderchatScript wonderchatKey={process.env.NEXT_PUBLIC_WONDERCHAT_TOKEN_STUDENT || ""} />
  }

  if (userRole === "student") {
    return <ZendeskScript zendeskKey={process.env.NEXT_PUBLIC_ZENDESK_KEY_STUDENT || ""} />
  }

  return null
}
